module.exports = __webpack_public_path__ + "assets/img/img173.4ae55461.png";